module.exports = __webpack_public_path__ + "static/media/photo-4.95a0ae8d.avif";